export type PerformanceGranularity = 'daily' | 'weekly' | 'monthly'

const PERFORMANCE_LABELS: Record<PerformanceGranularity, {
    name: string
    overview: string
    keyMetrics: string
    periodColumn: string
    trendColumn: string
}> = {
    daily: {
        name: 'Daily',
        overview: 'Daily performance',
        keyMetrics: 'Key metrics - Last two days',
        periodColumn: 'Day',
        trendColumn: 'DoD',
    },
    weekly: {
        name: 'Weekly',
        overview: 'Weekly performance',
        keyMetrics: 'Key metrics - Last two weeks',
        periodColumn: 'Week',
        trendColumn: 'WoW',
    },
    monthly: {
        name: 'Monthly',
        overview: 'Monthly performance',
        keyMetrics: 'Key metrics - Last two months',
        periodColumn: 'Month',
        trendColumn: 'MoM',
    },
}

export function normalizePerformanceGranularity(value: unknown): PerformanceGranularity {
    return value === 'daily' || value === 'weekly' || value === 'monthly' ? value : 'monthly'
}

export function getPerformanceLabels(granularity: PerformanceGranularity) {
    return PERFORMANCE_LABELS[granularity]
}

function parseDateValue(value: string) {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/)
    if (!match) return null

    const date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])))
    return Number.isFinite(date.getTime()) ? date : null
}

export function inferPerformanceGranularity(fromDate: string, toDate: string): PerformanceGranularity {
    const from = parseDateValue(fromDate)
    const to = parseDateValue(toDate)
    if (!from || !to || to < from) return 'monthly'

    const inclusiveDays = Math.round((to.getTime() - from.getTime()) / 86_400_000) + 1
    if (inclusiveDays === 1) return 'daily'
    if (inclusiveDays <= 14) return 'weekly'
    return 'monthly'
}
